export function getTypeOrderKiosk(isDefault?: boolean) {
  const typeKiosk = new URLSearchParams(window.location.search).get('type');
  if (isDefault) return typeKiosk || 'dinein';

  return typeKiosk;
}
